import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "checkbox", "uncheckBtn", "reselectBtn"]
  static values = {
    documentsByDomaine: Object
  }

  connect() {
    this.updateButtonsVisibility()
  }

  change() {
    const selectedDomaine = this.selectTarget.value

    if (selectedDomaine && selectedDomaine !== "") {
      this.selectDomaine(selectedDomaine)
    }

    this.updateButtonsVisibility()
  }

  selectDomaine(domaine) {
    const domaineDocuments = this.documentsByDomaineValue[domaine] || []

    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = domaineDocuments.includes(checkbox.value)
    })
  }

  uncheckAll() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
  }

  reselectDomaine() {
    const selectedDomaine = this.selectTarget.value
    if (selectedDomaine && selectedDomaine !== "") {
      this.selectDomaine(selectedDomaine)
    }
  }

  updateButtonsVisibility() {
    const hasSelectedDomaine = this.selectTarget.value && this.selectTarget.value !== ""

    if (this.hasUncheckBtnTarget) {
      this.uncheckBtnTarget.classList.toggle("hidden", !hasSelectedDomaine)
    }
    if (this.hasReselectBtnTarget) {
      this.reselectBtnTarget.classList.toggle("hidden", !hasSelectedDomaine)
    }
  }
}
